 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		117: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		117: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"15":"ExamBoostAnimation","16":"NoWrongAnswersAnimation","17":"quiz-animation","18":"transfer-subscription-no-children-animation","29":"ChatbotQuitAnimation","30":"ChatbotTypingAnimation","31":"FloralRewardAnimation","32":"NoClassesAnimation","33":"SenecaPremiumCardAnimation","34":"accept-challenge-animation","35":"adam-image","36":"all-child-assignments","37":"anonymous-course-discovery-chunk","38":"anonymous-resources-hub","39":"anonymous-resources-hub-chunk","40":"anonymous-what-is-premium-parent","41":"anonymous-what-is-premium-teacher","42":"assignment-complete-animation","43":"assignment-share-animation","44":"assignment-student-result-chunk","45":"ben-image","46":"calendar-image","47":"car-animation","48":"child-connected-modal","49":"child-connection-invite-journey","50":"child-not-found-route","51":"child-overview-page","52":"child-single-assignment","53":"child-sub-router","54":"circle-books-animation","55":"claim-tutoring-journey","56":"class-page-router","57":"classes-page","58":"classroom-chunk","59":"clock-animation","60":"confetti-animation","61":"correct-answer-animation","62":"courses-page","63":"courses-page-chunk","64":"creation-chunk","65":"cute-whale-animation","66":"dashboard-router-chunk","67":"date-fns-de","68":"date-fns-de-AT","69":"date-fns-en-AU","70":"date-fns-en-GB","71":"date-fns-en-IN","72":"date-fns-en-US","73":"date-fns-es","74":"date-fns-fr","75":"date-fns-pt-BR","76":"date-fns-vi","77":"delete-assignment-chunk","78":"dev-tools","79":"empty-desk-animation","80":"falling-confetti-animation","81":"feedback-success-animation","82":"front-door-chunk","83":"get-premium-chunk","84":"gostudent-logo-animation","85":"invite-all-school-parents","86":"invite-classes-parents-animation","87":"jane-image","88":"join-group-animation","89":"link-animation","90":"loading-blocks-animation","91":"magnifying-glass-animation","93":"manage-student-chunk","94":"marking-chunk","95":"medal-animation","96":"mia-image","97":"mobile-auth","98":"more-sub-router","99":"mumsnet-image","100":"new-courses-chunk","101":"no-assignments-animation","102":"no-course-info-animation","103":"no-study-time-animation","104":"noStudentsAssignmentsAnimation","105":"parent-claim-tutoring-journey-routes","106":"parent-dashboard","107":"parent-tutoring-page","108":"parent-what-is-premium-page","109":"parents-invite-route","110":"personalised-suggestions-courses-chunk","111":"plug-in-failed-animation","112":"plurall-help-centre-modal-chunk","113":"podium-animation","114":"pre-speedy-marking-chunk","115":"progress-page","116":"receive-gift-open-animation","118":"sad-look-animation","119":"section-preview","120":"session","121":"settings-page","122":"share-animation","123":"share-assignment-chunk","124":"sign-up-invite-chunk","125":"sleepy-animation","126":"smiling-with-hearts-animation","127":"speedyMarkingQuitAnimation","128":"speedyMarkingSuccessAnimation","129":"spinning-trophy-animation","130":"success-animation","131":"target-animation","132":"teacher-dashboard","133":"topic-score-animation","134":"transfer-subscription-error-animation","135":"transfer-subscription-success-animation","136":"trash-animation","137":"trophy-animation","138":"trustpilot-image","139":"try-a-module","140":"tutoring-activation-journey","141":"unlock-dark-mode-chunk","142":"weekly-reports-page","143":"what-is-premium-chunk","144":"workout-animation"}[chunkId]||chunkId) + "." + {"0":"31559b88","1":"6e95d1e6","2":"9fbd5ce2","3":"fbe1c136","4":"e2c6a9bb","5":"fdf3540c","6":"4ab2c390","7":"aafae503","8":"33f3a3da","9":"0bdb8e0c","10":"2e4f78ee","11":"e29c9a3a","12":"b240a3a3","13":"fd7a92a5","14":"09bcd066","15":"93154d2b","16":"c74d2aef","17":"4c01f43e","18":"0015c35c","19":"21e34153","20":"e89a8e85","21":"7816ee80","22":"23a2dfe8","23":"c0bd6fe8","24":"2552835b","25":"1bfdd2c1","26":"5c1e4cc0","27":"7b9d7d48","28":"76fa74db","29":"d2e6678c","30":"5106c894","31":"42bb3f37","32":"954ba8e3","33":"e83fc083","34":"6110f75c","35":"231d2b6b","36":"dabf7259","37":"35d453fc","38":"5791df87","39":"01bd7ca8","40":"71ceee78","41":"71a88c83","42":"93073b9c","43":"055c04e0","44":"c688738a","45":"90c0fc4a","46":"00937538","47":"4edcafe3","48":"ea93d3d8","49":"af491187","50":"fde8d252","51":"78221c68","52":"37e03bbf","53":"ec740bdb","54":"5bad45b3","55":"02575a2b","56":"c996f49a","57":"90ed3934","58":"92ca4d9e","59":"f9e1572a","60":"b08109ad","61":"1e0052fc","62":"2d591940","63":"141b8e61","64":"60cef9c1","65":"c35bd8f7","66":"ce1a380a","67":"806d5558","68":"90579ff2","69":"ceb7326b","70":"91a7774e","71":"3925eaf1","72":"6f6d9360","73":"b24bf253","74":"4157e146","75":"ef92392b","76":"5bbeb2a9","77":"ac749e8a","78":"838d5fd9","79":"9792f13d","80":"b9acea78","81":"937886dc","82":"473d51e8","83":"6a52dcaa","84":"1cffc155","85":"aa52cf4d","86":"35c44f59","87":"105816e1","88":"ca904a3b","89":"cfec0b15","90":"b4e3c52b","91":"d0c0ddc8","93":"cf7cef4e","94":"227b9f0b","95":"602a3a61","96":"e3da5157","97":"dc12e0a2","98":"8d4e2c37","99":"bf417dbf","100":"ede2ea28","101":"89585516","102":"8471d6b0","103":"3f724850","104":"1d53d749","105":"ac7b7da6","106":"87e22834","107":"3df7c895","108":"c1ae1da6","109":"d9bd69c2","110":"64d58737","111":"767b781f","112":"72d9986d","113":"53e41eef","114":"1602a63d","115":"6a926076","116":"cf59fe65","118":"d947fff4","119":"65a0390c","120":"7c16c5cf","121":"c2740645","122":"d1e9d455","123":"c33b8420","124":"273c2d6e","125":"f093948b","126":"1c57465c","127":"5d249057","128":"ab594835","129":"961aca50","130":"fefe5498","131":"cce30ee0","132":"56d0accf","133":"b0dd0a6d","134":"f11966ef","135":"39165589","136":"c1b68acb","137":"2ad3299a","138":"af8d1d2b","139":"0e55c2b6","140":"256e98fa","141":"d8395406","142":"275759e9","143":"7b612b6e","144":"2d5e2e6e","146":"55a347e1","147":"9f26cd4f","148":"768fcba8","149":"c843cfda","150":"4742f071","151":"bddebb34","152":"1c7be3cc","153":"0ee60c53","154":"0582be44"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"10":1,"11":1,"19":1,"20":1,"21":1,"23":1,"24":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"51":1,"52":1,"55":1,"56":1,"57":1,"58":1,"63":1,"64":1,"66":1,"77":1,"78":1,"82":1,"83":1,"93":1,"94":1,"97":1,"106":1,"107":1,"108":1,"115":1,"119":1,"120":1,"121":1,"123":1,"124":1,"132":1,"133":1,"139":1,"142":1,"143":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"15":"ExamBoostAnimation","16":"NoWrongAnswersAnimation","17":"quiz-animation","18":"transfer-subscription-no-children-animation","29":"ChatbotQuitAnimation","30":"ChatbotTypingAnimation","31":"FloralRewardAnimation","32":"NoClassesAnimation","33":"SenecaPremiumCardAnimation","34":"accept-challenge-animation","35":"adam-image","36":"all-child-assignments","37":"anonymous-course-discovery-chunk","38":"anonymous-resources-hub","39":"anonymous-resources-hub-chunk","40":"anonymous-what-is-premium-parent","41":"anonymous-what-is-premium-teacher","42":"assignment-complete-animation","43":"assignment-share-animation","44":"assignment-student-result-chunk","45":"ben-image","46":"calendar-image","47":"car-animation","48":"child-connected-modal","49":"child-connection-invite-journey","50":"child-not-found-route","51":"child-overview-page","52":"child-single-assignment","53":"child-sub-router","54":"circle-books-animation","55":"claim-tutoring-journey","56":"class-page-router","57":"classes-page","58":"classroom-chunk","59":"clock-animation","60":"confetti-animation","61":"correct-answer-animation","62":"courses-page","63":"courses-page-chunk","64":"creation-chunk","65":"cute-whale-animation","66":"dashboard-router-chunk","67":"date-fns-de","68":"date-fns-de-AT","69":"date-fns-en-AU","70":"date-fns-en-GB","71":"date-fns-en-IN","72":"date-fns-en-US","73":"date-fns-es","74":"date-fns-fr","75":"date-fns-pt-BR","76":"date-fns-vi","77":"delete-assignment-chunk","78":"dev-tools","79":"empty-desk-animation","80":"falling-confetti-animation","81":"feedback-success-animation","82":"front-door-chunk","83":"get-premium-chunk","84":"gostudent-logo-animation","85":"invite-all-school-parents","86":"invite-classes-parents-animation","87":"jane-image","88":"join-group-animation","89":"link-animation","90":"loading-blocks-animation","91":"magnifying-glass-animation","93":"manage-student-chunk","94":"marking-chunk","95":"medal-animation","96":"mia-image","97":"mobile-auth","98":"more-sub-router","99":"mumsnet-image","100":"new-courses-chunk","101":"no-assignments-animation","102":"no-course-info-animation","103":"no-study-time-animation","104":"noStudentsAssignmentsAnimation","105":"parent-claim-tutoring-journey-routes","106":"parent-dashboard","107":"parent-tutoring-page","108":"parent-what-is-premium-page","109":"parents-invite-route","110":"personalised-suggestions-courses-chunk","111":"plug-in-failed-animation","112":"plurall-help-centre-modal-chunk","113":"podium-animation","114":"pre-speedy-marking-chunk","115":"progress-page","116":"receive-gift-open-animation","118":"sad-look-animation","119":"section-preview","120":"session","121":"settings-page","122":"share-animation","123":"share-assignment-chunk","124":"sign-up-invite-chunk","125":"sleepy-animation","126":"smiling-with-hearts-animation","127":"speedyMarkingQuitAnimation","128":"speedyMarkingSuccessAnimation","129":"spinning-trophy-animation","130":"success-animation","131":"target-animation","132":"teacher-dashboard","133":"topic-score-animation","134":"transfer-subscription-error-animation","135":"transfer-subscription-success-animation","136":"trash-animation","137":"trophy-animation","138":"trustpilot-image","139":"try-a-module","140":"tutoring-activation-journey","141":"unlock-dark-mode-chunk","142":"weekly-reports-page","143":"what-is-premium-chunk","144":"workout-animation"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"5d9248fe","4":"e8fbe97e","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"95274648","11":"071f5736","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"32daf4cf","20":"51898f8a","21":"24c8c25e","22":"31d6cfe0","23":"50af7378","24":"6c6494c9","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"26dbc8e4","37":"66ea5b0b","38":"71d10f8d","39":"c8578852","40":"eae05a40","41":"eae05a40","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"6f2678f0","52":"de34e800","53":"31d6cfe0","54":"31d6cfe0","55":"04d055db","56":"bb9ef516","57":"db5294cb","58":"195bacc1","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"7c6e63ff","64":"4a94f66c","65":"31d6cfe0","66":"671a7fcc","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"31d6cfe0","75":"31d6cfe0","76":"31d6cfe0","77":"04d055db","78":"ad4d543f","79":"31d6cfe0","80":"31d6cfe0","81":"31d6cfe0","82":"2f8b818c","83":"34d7fb9f","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","91":"31d6cfe0","93":"9ad2052a","94":"02e92f81","95":"31d6cfe0","96":"31d6cfe0","97":"d8705ad5","98":"31d6cfe0","99":"31d6cfe0","100":"31d6cfe0","101":"31d6cfe0","102":"31d6cfe0","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"6cbed9e7","107":"04d055db","108":"3501bb7b","109":"31d6cfe0","110":"31d6cfe0","111":"31d6cfe0","112":"31d6cfe0","113":"31d6cfe0","114":"31d6cfe0","115":"b3dbd5ee","116":"31d6cfe0","118":"31d6cfe0","119":"99e12122","120":"eedd3518","121":"0fca8682","122":"31d6cfe0","123":"c8e9dbe2","124":"2f8b818c","125":"31d6cfe0","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"531d7e1d","133":"5a2bdb39","134":"31d6cfe0","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"31d6cfe0","139":"7964e5fa","140":"31d6cfe0","141":"31d6cfe0","142":"294d18fc","143":"7cae917b","144":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpseneca-web"] = this["webpackJsonpseneca-web"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
